import { action, set, setProperties } from '@ember/object';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert, didUpdate } from '@ember/render-modifiers';
import Component from '@glimmer/component';
import GeneralListsListItemsListItemExpandable from 'lumen/components/general/lists/list-items/list-item-expandable';

interface GeneralListsListSingleExpandSignature {
  Args: {
    expandComponent: unknown;
    isLoading: unknown;
    options: unknown;
  };
}

export default class GeneralListsListSingleExpand extends Component<GeneralListsListSingleExpandSignature> {
  mappedOptions = null;

  @action
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  didUpdateOptions() {
    if (this.args.options) {
      set(
        this,
        'mappedOptions',
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        this.args.options.map((option) => {
          const newOption = { isExpanded: false };
          setProperties(newOption, option);
          return newOption;
        }),
      );
    }
  }

  @action
  // @ts-expect-error: Incorrect type
  openExpandView(item, isExpanded): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.mappedOptions.forEach((option) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      set(option, 'isExpanded', false);
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    set(item, 'isExpanded', !isExpanded);
  }

  <template>
    <div
      class="list-item-expandable-container"
      {{didInsert this.didUpdateOptions}}
      {{didUpdate this.didUpdateOptions @options}}
    >
      {{#each this.mappedOptions as |option|}}
        <GeneralListsListItemsListItemExpandable
          @expandComponent={{@expandComponent}}
          @isLoading={{@isLoading}}
          {{! @glint-expect-error: Incorrect type }}
          @listActions={{this.listActions}}
          @onOpenExpandView={{this.openExpandView}}
          @option={{option}}
        />
      {{/each}}
    </div>
  </template>
}
